import BusinessRequests from '../requests/BusinessRequests';
import { CLEAR_BUSINESS, SET_BUSINESS, SET_BUSINESSES, SET_SUBMISSION } from './types';

const requests = new BusinessRequests();

export const setBusinesses = (data, meta) => ({
  type: SET_BUSINESSES,
  payload: { items: data, meta },
});

export const setBusiness = (data) => ({
  type: SET_BUSINESS,
  payload: data,
});

export const clearBusiness = () => ({
  type: CLEAR_BUSINESS,
});

export const setSubmission = (payload) => ({
  type: SET_SUBMISSION,
  payload,
});

/**
 * `sort=placement_ASC` is the default everywhere a list is shown: it puts paid
 * tiers first and orders the rest by name. Plain name order would bury the
 * listings that pay for the site.
 */
export const loadBusinesses = (filters = {}, page = 1) =>
  requests.get({
    wheres: filters,
    withs: ['town', 'category', 'primaryImage'],
    sort: 'placement_ASC',
    limit: 24,
    page,
    label: 'BUSINESSES',
    onSuccess: (data, meta) => setBusinesses(data, meta),
  });

export const loadBusiness = (slug) =>
  requests.findBySlug({
    slug,
    label: 'BUSINESS',
    onSuccess: (data) => setBusiness(data),
    onFailure: () => setBusiness(null),
  });

export const submitListing = (data, { onDone } = {}) =>
  requests.create({
    data,
    label: 'SUBMIT',
    onSuccess: (created) => {
      if (onDone) onDone(null, created);

      return setSubmission({ status: 'accepted', listing: created });
    },
    onFailure: (error) => {
      if (onDone) onDone(error);

      return setSubmission({
        status: 'failed',
        errors: error?.response?.data?.validationErrors || null,
        message: error?.response?.data?.error || 'Something went wrong. Try again.',
      });
    },
  });
